export default __webpack_public_path__ + "static/media/apollo-solar-bg.ac63e0bf.jpeg";